import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGem, faHandPointer } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import './SubscriptionModal.css';

const SubscriptionModal = ({ show, onHide }) => {
    const navigate = useNavigate();

    const handleSubscribe = () => {
        // Redirect to subscription page or WhatsApp
        window.open('https://story.fictiongenie.com', '_blank');
    };

    const handleDismiss = () => {
        onHide();
        navigate('/');
    };

    return (
        <Modal
            show={show}
            onHide={handleDismiss}
            centered
            className="subscription-modal"
            backdrop="static"
        >
            <Modal.Body className="text-center p-5">
                <div className="premium-icon-container mb-4">
                    <FontAwesomeIcon icon={faGem} size="4x" className="premium-gem" />
                </div>
                <h2 className="premium-title mb-3">Unlock This Magic!</h2>
                <p className="premium-text mb-4">
                    This enchanting story is part of our <strong>Premium Collection</strong>.
                    Upgrade to a paid plan to read this and access our entire library of adventures!
                </p>
                <div className="d-grid gap-3">
                    <Button
                        variant="primary"
                        size="lg"
                        className="upgrade-btn"
                        onClick={handleSubscribe}
                    >
                        <FontAwesomeIcon icon={faHandPointer} className="me-2" />
                        Upgrade to Premium
                    </Button>
                    <Button
                        variant="outline-light"
                        className="dismiss-btn"
                        onClick={handleDismiss}
                    >
                        I will do it later
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default SubscriptionModal;
